import { render, staticRenderFns } from "./ModalConfirmaCancelamentoAgendamento.vue?vue&type=template&id=285b6cfd"
import script from "./ModalConfirmaCancelamentoAgendamento.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmaCancelamentoAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalConfirmaCancelamentoAgendamento.vue?vue&type=style&index=0&id=285b6cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports